var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", {
      staticClass:
        "bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0",
      staticStyle: { height: "50px" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col md:flex-row" }, [
      _c(
        "div",
        { staticClass: "main-content flex-1 bg-gray-100 mt-12 md:mt-2" },
        [
          _c(
            "div",
            { staticClass: "bg-blue-800 p-2 shadow text-xl text-white" },
            [
              _c(
                "div",
                { staticClass: "bg-grey-lighter min-h-screen flex flex-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white px-6 pt-4 pb-8 rounded shadow-md text-black w-full"
                        },
                        [
                          _c("img", {
                            staticClass: "m-auto",
                            staticStyle: { width: "150px" },
                            attrs: {
                              src: require("@/assets/musicverse-logo.png")
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "h1",
                            { staticClass: "mb-8 text-3xl text-center" },
                            [_vm._v(_vm._s(_vm.title))]
                          ),
                          _vm._v(" "),
                          _c("h2", { staticClass: "mb-8 text-xl text-left" }, [
                            _vm._v(_vm._s(_vm.message))
                          ]),
                          _vm._v(" "),
                          _c("h2", { staticClass: "mb-8 text-xl text-left" }, [
                            _vm._v(_vm._s(_vm.body))
                          ]),
                          _vm._v(" "),
                          !_vm.error
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "w-full\n                      text-center\n                      py-3 rounded\n                      bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.isLoading
                                  },
                                  on: { click: _vm.nextProcess }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.labelSave) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "h1",
                                { staticClass: "mb-8 text-center" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "text-blue-400 cursor-pointer",
                                      attrs: { to: { name: "Signin" } }
                                    },
                                    [_vm._v("back to login page")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("ModalTermAndConditions", {
                    attrs: {
                      isShowingModal: _vm.isShowingModalTermsandCondition
                    },
                    on: {
                      toggleModal: function($event) {
                        return _vm.toggleModalTermsandCondition()
                      },
                      save: function($event) {
                        return _vm.verifyAccount()
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b8e5ef7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8e5ef7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VerificationEmail.vue
// module id = null
// module chunks = 